import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import WifiProtectedSetupIcon from "@mui/icons-material/WifiProtectedSetup";

import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import AddCardIcon from "@mui/icons-material/AddCard";
import Tooltip from "@mui/material/Tooltip";
import { useAuth } from "../../Context/AuthContext";
import SearchIcon from "@mui/icons-material/Search";
import AddRevenueDialog from "./AddRevenueDialog";
import UpdateLeadsAndClients from "./UpdateLeadsAndClients";
import Interactionmodal from "./Interactionmodal";
import Addclientinteractions from "./Addclientinteractions";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const style = {
  position: "fixed",
  top: "54%",
  // left: "85%",
  right: "-175px",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: 620,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
  overflow: "auto",

  scrollbarWidth: "thin", // For Firefox
  scrollbarColor: "#d9d9d9 #fff", // For Firefox
  "&::-webkit-scrollbar": {
    width: "2px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#d9d9d9",
  },
};

const sxStyles = {
  boldHeader: {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
};

const DroppedInt = () => {
  const { token } = useAuth();

  const roleId = sessionStorage.getItem("roleId");
  const userId = sessionStorage.getItem("userId");
  const firstName = sessionStorage.getItem("firstname");
  const lastName = sessionStorage.getItem("lastname");
  const [isChangeStatusModalOpen, setIsChangeStatusModalOpen] = useState(false);

  //--------------------add client-modal----------------------|\

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  //----------------------------------------------------------|\

  const [referrals, setReferrals] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  const [isRevenueDialogOpen, setIsRevenueDialogOpen] = useState(false);
  const [newLead, setNewLead] = useState(false);

  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("initial");
  const [rmOptions, setRmOptions] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");

  const [selectedLeadName, setSelectedLeadName] = useState("");
  const [selectedInteractions, setSelectedInteractions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [locationTypes, setlocationTypes] = useState([]);
  const [statustypes, setStatustypes] = useState([]);
  const [leadstatustypes, setleadstatustypes] = useState([]);
  const [annualincometypes, setannualincometypes] = useState([]);

  const [selectedData, setSelectedData] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const handleLeadNameClick = (leadName, interactions) => {
    console.log("leadname", leadName);
    console.log("leadname2", interactions);
    setSelectedLeadName(leadName);
    setSelectedInteractions(interactions);
    setModalOpen(true);
  };

  const cancelHandler = () => {
    // handleCloseChangeStatusModal();
    // reset();
    setModalOpen(false);
  };

  const handleChangeStatus = (referralId) => {
    setSelectedLead(referralId);
    setSelectedId(referralId);
    setIsChangeStatusModalOpen(true);
  };

  const handleCloseStatusModal = () => {
    setSelectedLead(null);
    setIsChangeStatusModalOpen(false);
  };

  const handleOpenModal = (rowData) => {
    setSelectedData(rowData);
    console.log("clkes inside modal");
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setSelectedData(null);
    setOpenModal(false);
  };

  const fetchReferralLead = async () => {
    setLoading(true);
    const headers = {
      "x-access-token": token,
    };
    try {
      // Your API call logic here
      const apiResponse = await axios.get(
        `${apiUrl}/CCE/api/v1/referalEngine/droppedReferrals`,
        { headers }
      );
      if (apiResponse) {
        // setClientList(apiResponse?.data?.response);
        // const apiData = apiResponse?.data?.response;
        // setReferrals(apiData);

        // -----------------------------------------------------|\
        const apiData = apiResponse?.data?.response;
        const filteredReferrals = apiData.filter((referral) => {
          const fullName =
            `${referral.firstname} ${referral.lastname}`.toLowerCase();
          const email = (referral.email || "").toLowerCase();
          const query = searchQuery.toLowerCase();
          return (
            searchQuery === "" ||
            fullName.includes(query) ||
            email.includes(query)
          );
        });
        setReferrals(filteredReferrals);
        // -----------------------------------------------------|\
      }
      console.log("apiClient", apiResponse?.data?.response);
    } catch (error) {
      console.error("Error fetching graph data:", error.message);
    }
    setLoading(false);
  };
  console.log("rf", referrals);

  useEffect(() => {
    fetchReferralLead();
    setNewLead(false);
  }, [newLead, searchQuery, status]);
  //------------------------------------------------------------
  useEffect(() => {
    const handleRole = async () => {
      try {
        if (roleId === "1" || roleId === "6") {
          console.log("roles", roleId);
          const apiResult = await axios.post(
            `${apiUrl}/CCE/api/v1/userEngine/users`,
            {
              roleId: 2,
            }
          );
          setRmOptions(apiResult?.data?.response);
        } else if (roleId === "2") {
          setValue("rm", `${firstName} ${lastName}`);
          // setValue("rm", userId);
        }
      } catch (error) {
        console.error("Error fetching rm data:", error.message);
      }
    };

    handleRole();
  }, [roleId, userId]);

  const handleStatusUpdate = (newStatus) => {
    setStatus(newStatus);
  };
  //--------------------------------------
  const formatPhoneNumber = (phoneNumber) => {
    const phoneNumberString = phoneNumber.toString();
    const formattedNumber = `${phoneNumberString.substring(
      0,
      5
    )} ${phoneNumberString.substring(5)}`;
    return formattedNumber;
  };
  //--------------------------------------
  const formatDateString = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB");
    } else {
      return "N/A";
    }
  };
  const formatDateStringhours = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return `${date.toLocaleDateString("en-GB")} ${date.toLocaleTimeString(
        "en-GB",
        { hour: "2-digit", minute: "2-digit" }
      )}`;
    } else {
      return "N/A";
    }
  };
  //--------------------------------------

  // const handleOpenModal = (rowData) => {
  //   setSelectedData(rowData);
  //   console.log("clkes inside modal")
  //   setOpenModal(true);
  // };

  const getLocationtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/location_type`;
      const response = await axios.get(url, {
        // Include any data that needs to be sent in the request body here
      });
      console.log("locationdata", response);
      setlocationTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const getstatustypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/status`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setStatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getLeadstatusData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/lead_status`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setleadstatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getAnnualincomeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/estimated_annual_income`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setannualincometypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    // getEngagementtypeData();
    getLocationtypeData();
    getstatustypeData();
    getLeadstatusData();
    getAnnualincomeData();
  }, []);

  const mainColumns = [
    // {
    //   field: "referralName",
    //   headerName: "Client Name",
    //   renderCell: (params) => (
    //     <div>
    //       {params.row.firstname} {params.row.lastname}
    //     </div>
    //   ),
    //   width: 160,
    // },
    {
      field: "referralName",
      headerName: "Client Name",
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "140px",
          }}
          title={`${params.row.firstname} ${params.row.lastname}`}
          // onClick={() => handleLeadNameClick(`${params.row.firstname} ${params.row.lastname}`, params.row.interactionDetails
          //   )}
          // style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
        >
          {params.row.firstname} {params.row.lastname}
        </div>
      ),
      width: 160,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "email",
      headerName: "Email Address",
      width: 200,
      headerClassName: "boldHeader",
      valueGetter: (params) => params.value || "-",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "phone",
      headerName: "Phone Number",
      // type: "number",
      valueFormatter: (params) => formatPhoneNumber(params.value),
      width: 160,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "firstContactDate",
      headerName: "First Contact Date",
      valueFormatter: (params) => formatDateString(params.value),
      width: 160,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "leadReferredBy",
      headerName: "Referred By",
      width: 160,
      headerClassName: "boldHeader",
      valueGetter: (params) => params.value || "-",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "source",
      headerName: "Source",
      width: 160,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      valueGetter: (params) => {
        if (params.value === "referral") return "Partner Referred";
        if (params.value === "outbound") return "Self Referred";
        if (params.value === "inbound") return "Client";
        return "N/A";
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 160,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      renderCell: (params) => {
        // Capitalize the first letter of the status value
        const status = params.row.status;
        const formattedStatus = status
          ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
          : ""; // Handle null or undefined cases

        return <div>{formattedStatus}</div>;
      },
    },

    // ...(roleId === "1"
    //   ? [{ field: "managerName", headerName: "Manager", width: 160,      headerClassName: "boldHeader",
    //   }]
    //   : []),
    // {
    //   field: "action",
    //   headerName: "Action",
    //   sortable: false,
    //   width: 160,
    //   renderCell: (params) => (
    //     <Box>
    //       <Tooltip title="Edit">
    //         <IconButton
    //           variant="outlined"
    //           size="small"
    //           onClick={() => handleEditClick(params.row.id)}
    //         >
    //           <EditIcon />
    //         </IconButton>
    //       </Tooltip>
    //       {roleId !== "2" && (
    //         <Tooltip title="Delete">
    //           <IconButton
    //             variant="outlined"
    //             size="small"
    //             // onClick={() => handleDeleteClick(params.row.id)}
    //           >
    //             <DeleteIcon />
    //           </IconButton>
    //         </Tooltip>
    //       )}
    //       {/* <Tooltip title="Add Revenue">
    //         <IconButton
    //           variant="outlined"
    //           size="small"
    //           onClick={() => handleRevenueClick(params.row.id)}
    //         >
    //           <AddCardIcon />
    //         </IconButton>
    //       </Tooltip> */}
    //       <Tooltip title="Add Interctions">
    //         <IconButton
    //           variant="outlined"
    //           size="small"
    //           onClick={() => handleChangeStatus(params.row.id)}
    //         >
    //           <WifiProtectedSetupIcon/>
    //         </IconButton>
    //       </Tooltip>
    //     </Box>
    //   ),
    // },
  ];

  const interactionColumns = [
    {
      field: "meeting_at",
      headerName: "Meeting Date",
      width: 150,
      renderCell: (params) => (
        <div>
          <div
            onClick={() => handleOpenModal(params.row)}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {formatDateString(params.value)}
          </div>
        </div>
      ),
    },
    {
      field: "location_type",
      headerName: "Location Type",
      width: 150,
      renderCell: (params) => (
        <div>
          {
            locationTypes.find((item) => item.id === params.value)
              ?.masterValueDesc
          }
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => (
        <div>
          {
            statustypes.find((item) => item.id === params.value)
              ?.masterValueDesc
          }
        </div>
      ),
    },
    {
      field: "lead_status",
      headerName: "Lead Status",
      width: 150,
      renderCell: (params) => (
        <div>
          {
            leadstatustypes.find((item) => item.id === params.value)
              ?.masterValueDesc
          }
        </div>
      ),
    },

    {
      field: "expected_date_of_closure",
      headerName: "Exp.Dt.Closure",
      valueFormatter: (params) => formatDateStringhours(params.value),
      width: 170,
    },
    {
      field: "estimated_annual_income",
      headerName: "Est.Annual Income",
      width: 170,
      renderCell: (params) => (
        <div>
          {
            annualincometypes.find((item) => item.id === params.value)
              ?.masterValueDesc
          }
        </div>
      ),
    },
    {
      field: "followup_date_n_time",
      headerName: "F.Up Date",
      valueFormatter: (params) => formatDateString(params.value),
      width: 150,
    },
    //  {
    //   field: 'action',
    //   headerName: 'Action',
    //   width: 100,
    //   renderCell: (params) => (
    //     <DeleteIcon
    //       style={{ cursor: 'pointer' }}
    //       // onClick={() => handleDeleteClickdelete(params.row.id)}
    //     />
    //   ),
    // },
  ];

  const renderInteractionDetails = (params) => {
    const { interactionDetails } = params.row;
    return (
      <div style={{ width: "100%" }}>
        {interactionDetails && interactionDetails.length > 0 ? (
          <DataGrid
            rows={interactionDetails}
            columns={interactionColumns}
            autoHeight
            hideFooter
          />
        ) : (
          <div>No Interaction Details</div>
        )}
      </div>
    );
  };

  //---------------------------------Edit-------------------------------------|\

  const handleEditClick = (referralId) => {
    setSelectedLead(referralId);
    setSelectedId(referralId);
    setIsEditDialogOpen(true);
  };

  const handleCloseEditDialog = () => {
    setSelectedLead(null);
    setIsEditDialogOpen(false);
  };

  // const handleEditSave = () => {
  //   // Handle edit save logic here (API call or state update)
  //   // After editing, fetch referrals again
  //   // For demonstration purposes, let's assume a function updateReferral is available
  //   updateReferral(selectedLead).then(() => {
  //     fetchReferralLead();
  //     handleCloseEditDialog();
  //   });
  // };

  //-------------------------------Delete---------------------------------|\

  // const handleDeleteClick = (referralId) => {
  //   // Handle delete logic here (API call or state update)
  //   // After deleting, fetch referrals again
  //   // For demonstration purposes, let's assume a function deleteReferral is available
  //   deleteReferral(referralId).then(() => {
  //     fetchReferralLead();
  //   });
  // };

  //--------------------------------Revenue--------------------------------|\

  const handleRevenueClick = (referralId) => {
    setSelectedLead(referralId);
    setSelectedId(referralId);
    setIsRevenueDialogOpen(true);
    console.log(referralId);
  };

  const handleCloseRevenueDialog = () => {
    setSelectedLead(null);
    setIsRevenueDialogOpen(false);
  };

  //-------------------------------   data  --------------------------------|\
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ mode: "onTouched" });

  // ------------------------------onSubmit----------------------------------|\

  const onSubmit = async (data) => {
    const headers = {
      "x-access-token": token,
    };
    try {
      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/referalEngine/preReferral`,
        {
          ...data,
          countryCode: +91,
          clientId: 4,
          status: "client",
          source: "inbound",
          created_by: sessionStorage.getItem("userId"),
        },
        { headers }
      );
      console.log("rp", response);
      // console.log("Response:", response.data.response.message);
      if (response.data.userAlreadyExist) {
        toast.error("Email or mobile already exist!");
        return;
      }
      if (response?.data?.response?.message === "Referral added Successfully") {
        toast.success("Client added successfully!");
        // const userId = response.data.response.id;
        handleClose();
        setNewLead(true);
        reset();
      }
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Failed to add Client.");
    }
  };
  // ----------------------------------------------------------------------------|\

  const handleCancel = () => {
    reset();
    handleClose();
  };
  const handleDownloadCSV = () => {
    const csvData = referrals.map((row) => ({
      "Lead Name": `${row.firstname} ${row.lastname}`,
      "Email Address": row.email || "-",
      "Phone Number": row.phone || "-",
      "First Contact Date": formatDateString(row.firstContactDate),
      "Referred By": row.leadReferredBy || "-",
      Source:
        row.source === "referral"
          ? "Partner Referred"
          : row.source === "outbound"
          ? "Self Referred"
          : row.source === "inbound"
          ? "Client"
          : "N/A",
      Status: row.status,
    }));

    return csvData;
  };
  //---------------------------------for Modal close------------------------------|\

  return (
    <Box sx={styles.main_container}>
      <Paper sx={styles.dashboard_paper}>
        <h3>Dropped Leads</h3>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            p: 1,
            justifyContent: "flex-end",
            width: "50%",
            marginLeft: "auto",
          }}
        >
          <Button
            sx={styles.btnback}
            variant="contained"
            onClick={() => navigate("/employeedashboard")}
          >
            Back
          </Button>
        </Box>
      </Paper>
      <Box
        sx={{
          width: "100%",
          height: "90vh",
          background: "#f2f2f2",
        }}
      >
        {/* -------------------------------------------------------------------------------------- */}
        <Paper
          elevation={3}
          sx={{
            margin: "10px 20px 20px 20px",
            height: "590px",
            borderRadius: "12px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "5px 15px",
              alignItems: "flex-end",
            }}
          >
            <Box sx={{ textAlign: "left" }}>
              {/* ----------------------------Filter--------------------------------------- */}
              <Box
                sx={{
                  textAlign: "left",
                  position: "relative",
                  margin: "5px 0px",
                }}
              >
                <input
                  style={{
                    width: "200px",
                    height: "30px",
                    fontSize: "11px",
                    borderRadius: "8px",
                    paddingLeft: "35px", // Adjust padding to make space for the icon
                  }}
                  type="text"
                  placeholder="Search by Client Name / Email"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <SearchIcon
                  sx={{
                    position: "absolute",
                    left: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "grey",
                  }}
                />
                {(roleId === "1" || roleId === "6" || roleId === "7") && (
                  <CSVLink
                    data={handleDownloadCSV()}
                    filename="dropped leads.csv"
                    style={{ textDecoration: "none" }}
                  >
                    <Button sx={styles.btn} variant="contained">
                      Download CSV
                    </Button>
                  </CSVLink>
                )}
              </Box>
              {/* ---------------------------------------------------------------------- */}
            </Box>
            {/* <Button onClick={handleOpen} sx={styles.btn} variant="contained">
              Add New Client
            </Button> */}
          </Box>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50%",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <div style={{ height: 524, width: "100%", overflow: "auto" }}>
              <DataGrid
                loading={loading}
                rows={referrals}
                columns={mainColumns}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}
                getRowId={(row) => row.id}
                autoHeight
                disableSelectionOnClick
                getDetailPanelContent={renderInteractionDetails}
                // pageSize={5}
                // rowsPerPageOptions={[5, 10, 20]}
                getDetailPanelHeight={() => "auto"}
                // sx={sxStyles.boldHeader}
                sx={{
                  ...sxStyles.boldHeader,
                  fontSize: "13px",
                  "& .MuiDataGrid-columnHeaders": {
                    textAlign: "center",
                    fontWeight: "bold",
                  },
                  "& .centerAlign": {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  },
                }}
              />
              <Modal
                open={modalOpen}
                // onClose={handleCloseModalnew}
                aria-labelledby="interaction-details-modal-title"
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    right: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 1200,
                    maxHeight: 600,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: "2px",
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "#d9d9d9 #fff", // For Firefox
                    "&::-webkit-scrollbar": {
                      width: "2px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#d9d9d9",
                    },
                  }}
                >
                  <Box
                    onClick={cancelHandler}
                    sx={{
                      textAlign: "right",
                      cursor: "pointer",
                      color: "#666666",
                    }}
                  >
                    <CloseIcon sx={{ fontSize: 30 }} />
                  </Box>
                  <Typography
                    sx={{ marginBottom: "12px" }}
                    id="interaction-details-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    <b>Interaction Details for {selectedLeadName}</b>
                  </Typography>
                  {selectedInteractions?.length > 0 ? (
                    <>
                      <div style={{ height: 400, width: "100%" }}>
                        <DataGrid
                          rows={selectedInteractions}
                          columns={interactionColumns}
                          pageSize={5}
                          rowsPerPageOptions={[5]}
                        />
                      </div>

                      {/* <Dialog
        open={opendelete}
        onClose={handleClosedelete}
      >
        <DialogTitle>{"Are you sure you want to delete?"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosedelete} color="primary">
            No
          </Button>
          <Button onClick={handleConfirmDelete} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog> */}
                    </>
                  ) : (
                    <Typography sx={{ marginTop: "12px" }}>
                      No interaction details available.
                    </Typography>
                  )}
                </Box>
              </Modal>
            </div>
          )}
          <Interactionmodal
            open={openModal}
            onClose={handleCloseModal}
            selectedData={selectedData}
          />
          {/* ---------------------------=-Edit Modal------------------------ */}

          <UpdateLeadsAndClients
            isEditDialogOpen={isEditDialogOpen}
            handleCloseEditDialog={handleCloseEditDialog}
            clientList={referrals}
            selectedId={selectedId}
            roleId={roleId}
            onStatusUpdate={handleStatusUpdate}
          />
          {/* -------------------- */}
          <Addclientinteractions
            isChangeStatusModalOpen={isChangeStatusModalOpen}
            handleCloseChangeStatusModal={handleCloseStatusModal}
            clientList={referrals}
            selectedId={selectedId}
            roleId={roleId}
            onStatusUpdate={handleStatusUpdate}
          />
          {/* ----------------- */}
          {/* --------------------------Revenue Modal------------------------ */}

          <AddRevenueDialog
            isRevenueDialogOpen={isRevenueDialogOpen}
            handleCloseRevenueDialog={handleCloseRevenueDialog}
            clientList={referrals}
            selectedId={selectedId}
            // onStatusUpdate={handleStatusUpdate}
          />
          {/* ---------------------------------------------------------------- */}
        </Paper>
        <Box>
          <ToastContainer
            position="bottom-right"
            autoClose={7000}
            newestOnTop={true}
            closeOnClick
            pauseOnHover
            toastStyle={{ textAlign: "left" }}
            theme="colored"
          />
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "-20px",
                  marginBottom: "20px",
                }}
              >
                <CloseIcon
                  sx={{ color: "#b3b3b3", cursor: "pointer" }}
                  onClick={handleClose}
                />
                <Typography variant="h6" sx={{ ml: 12 }}>
                  New Client
                </Typography>
              </Box>
              {/* --------------------------------------LM----------------------- */}
              <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-basic"
                    label="First name"
                    variant="outlined"
                    {...register("firstname", {
                      required: "First Name is required",
                      pattern: {
                        value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                        message: "Only alphabets are allowed",
                      },
                    })}
                  />
                  {errors.firstname && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.firstname.message}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-basic"
                    label="Last name"
                    variant="outlined"
                    {...register("lastname", {
                      required: "Last Name is required",
                      pattern: {
                        value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                        message: "Only alphabets are allowed",
                      },
                    })}
                  />
                  {errors.lastname && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.lastname.message}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-basic"
                    label="Email address"
                    variant="outlined"
                    {...register("email", {
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Invalid Email Address",
                      },
                      validate: (value) =>
                        !!value ||
                        !!watch("phone") ||
                        "Either Email or Phone is required",
                    })}
                  />
                  {errors.email && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.email.message}
                    </div>
                  )}
                </div>
                <div style={{ margin: "16px 0px 14px 0px" }}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-basic"
                    label="Phone number"
                    variant="outlined"
                    {...register("phone", {
                      pattern: {
                        value: /^\d{10}$/,
                        message: "Invalid Phone Number (10 digits)",
                      },
                      validate: (value) =>
                        !!value ||
                        !!watch("email") ||
                        "Either Email or Phone is required",
                      onChange: (e) =>
                        (e.target.value = e.target.value.replace(/\D/g, "")),
                    })}
                  />
                  {errors.phone && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.phone.message}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-comments"
                    label="Comments (optional)"
                    type="comments"
                    variant="outlined"
                    {...register("comments")}
                  />
                  {errors.comments && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.comments.message}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-leadReferredBy"
                    label="Referred by"
                    type="leadReferredBy"
                    variant="outlined"
                    {...register("leadReferredBy", {
                      pattern: {
                        value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                        message: "Only alphabets are allowed",
                      },
                    })}
                  />
                  {errors.leadReferredBy && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.leadReferredBy.message}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    id="outlined-date"
                    label="1st contact date"
                    type="date"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    {...register("firstContactDate", {
                      required: "Date is required",
                    })}
                    InputProps={{
                      inputProps: {
                        placeholder: "Select Date",
                        max: new Date().toISOString().split("T")[0],
                        defaultValue: new Date().toISOString().split("T")[0],
                      },
                    }}
                  />
                  {errors.firstContactDate && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.firstContactDate.message}
                    </div>
                  )}
                </div>
                {roleId === "2" && (
                  <div style={{ marginTop: "16px" }}>
                    <TextField
                      size="small"
                      sx={styles.textfield}
                      id="outlined-password"
                      label="Rm"
                      type="rm"
                      variant="outlined"
                      defaultValue={`${firstName} ${lastName}`}
                      InputProps={{ readOnly: true }}
                      {...register("rm", {
                        required: "RM is required",
                      })}
                    />
                    {errors.rm && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          textAlign: "left",
                          marginLeft: "10px",
                        }}
                      >
                        {errors.rm.message}
                      </div>
                    )}
                  </div>
                )}
                {(roleId === "1" || roleId === "6") && (
                  <div style={{ marginTop: "16px" }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="rm-select-label">RM</InputLabel>
                      <Controller
                        name="rm"
                        control={control}
                        defaultValue={null}
                        rules={{ required: "RM is required" }}
                        render={({ field }) => (
                          <Select
                            label="RM"
                            labelId="rm-select-label"
                            {...field}
                            sx={styles.textfield}
                          >
                            {rmOptions.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.firstname} {option.lastname}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                    </FormControl>
                    {errors.rm && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          textAlign: "left",
                          marginLeft: "10px",
                        }}
                      >
                        {errors.rm.message}
                      </div>
                    )}
                  </div>
                )}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "2rem",
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={handleCancel}
                    sx={{
                      color: "Black",
                      marginRight: "10px",
                      textTransform: "none",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="outlined"
                    sx={{
                      padding: "5px 15px",
                      background: "#002C51",
                      color: "#fff",
                      marginLeft: "10px",
                      textTransform: "none",
                      "&:hover": { background: "#002C51" },
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </form>
              {/* --------------------------------------LM----------------------- */}
            </Box>
          </Modal>
        </Box>
      </Box>
    </Box>
  );
};

// // Dummy functions for demonstration purposes
// const deleteReferral = async (referralId) => {
//   // API call or state update logic for deleting referral
//   console.log(`Deleted referral with ID ${referralId}`);
// };

// const updateReferral = async (updatedReferral) => {
//   // API call or state update logic for updating referral
//   console.log("Updated referral:", updatedReferral);
// };

export default DroppedInt;

const styles = {
  main_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "91vh",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "0px 20px",
  },
  btn: {
    width: "140px",
    margin: "10px 11px",
    fontSize: "11px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    width: "340px",
  },
  btnback: {
    width: "80px",
    fontSize: "11px",
    marginTop: "3px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
};
